var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNeo4J(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1540_289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1540_289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.3157 36.5438C70.3157 53.9411 56.1432 68.0421 38.6578 68.0421C21.1724 68.0421 7 53.9411 7 36.5438C7 19.1465 21.1724 5.04542 38.6578 5.04542C56.1432 5.02953 70.3161 19.1465 70.3161 36.5438",
    fill: "#008DC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0346 26.2121C21.0346 27.6009 19.8995 28.7303 18.5037 28.7303C17.1078 28.7303 15.9727 27.6009 15.9727 26.2121C15.9727 24.8232 17.1078 23.6939 18.5037 23.6939C18.8363 23.693 19.1658 23.7575 19.4733 23.8837C19.7808 24.01 20.0601 24.1954 20.2953 24.4294C20.5305 24.6634 20.7169 24.9414 20.8438 25.2473C20.9707 25.5533 21.0355 25.8811 21.0346 26.2121",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.464 33.1247C21.464 34.5135 20.3289 35.6428 18.933 35.6428C17.5372 35.6428 16.4021 34.5135 16.4021 33.1247C16.4021 31.7358 17.5372 30.6065 18.933 30.6065C19.2657 30.6056 19.5952 30.6701 19.9027 30.7963C20.2101 30.9226 20.4895 31.108 20.7247 31.342C20.9599 31.576 21.1463 31.854 21.2732 32.1599C21.4 32.4659 21.4649 32.7937 21.464 33.1247",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0128 40.4495C23.0128 41.8383 21.8778 42.9677 20.4819 42.9677C19.086 42.9677 17.9509 41.8383 17.9509 40.4495C17.9509 39.0607 19.086 37.9313 20.4819 37.9313C21.8782 37.9162 23.0128 39.0456 23.0128 40.4495ZM26.4796 47.0118C26.4796 48.4007 25.3445 49.53 23.9486 49.53C22.5527 49.53 21.4177 48.4007 21.4177 47.0118C21.4177 45.623 22.5527 44.4936 23.9486 44.4936C25.3445 44.4785 26.4796 45.6079 26.4796 47.0118",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5819 56.1837C53.5819 57.5726 52.4468 58.7019 51.051 58.7019C49.6551 58.7019 48.52 57.5726 48.52 56.1837C48.52 54.7949 49.6551 53.6655 51.051 53.6655C52.4468 53.6655 53.5819 54.7949 53.5819 56.1837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1832 50.7662C58.1832 52.1551 57.0482 53.2844 55.6523 53.2844C54.2564 53.2844 53.1213 52.1551 53.1213 50.7662C53.1213 49.3774 54.2564 48.248 55.6523 48.248C57.0482 48.248 58.1832 49.3778 58.1832 50.7662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8392 12.4611C44.8392 13.8499 43.7041 14.9793 42.3082 14.9793C40.9124 14.9793 39.7773 13.8499 39.7773 12.4611C39.7773 11.0722 40.9124 9.94287 42.3082 9.94287C43.7041 9.94287 44.8392 11.0722 44.8392 12.4611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1825 10.1378C38.1825 11.5267 37.0475 12.656 35.6516 12.656C34.2557 12.656 33.1202 11.5306 33.1202 10.1378C33.1202 8.74501 34.2553 7.61963 35.6512 7.61963C37.0471 7.61963 38.1821 8.74938 38.1821 10.1378",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1281 45.8219C65.4462 45.8219 73 38.3061 73 29.035C73 19.7638 65.4462 12.248 56.1281 12.248C46.81 12.248 39.2562 19.7638 39.2562 29.035C39.2562 38.3061 46.81 45.8219 56.1281 45.8219Z",
    fill: "#68B346",
    stroke: "white",
    strokeWidth: 1.18069
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0136 76.9996C40.6375 76.9996 46.8178 70.8504 46.8178 63.2649C46.8178 55.6795 40.6375 49.5303 33.0136 49.5303C25.3898 49.5303 19.2094 55.6795 19.2094 63.2649C19.2094 70.8504 25.3898 76.9996 33.0136 76.9996Z",
    fill: "#68B346",
    stroke: "white",
    strokeWidth: 1.18069
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6482 21.3129C26.7307 21.3129 30.851 17.2134 30.851 12.1564C30.851 7.09947 26.7307 3 21.6482 3C16.5656 3 12.4454 7.09947 12.4454 12.1564C12.4454 17.2134 16.5656 21.3129 21.6482 21.3129Z",
    fill: "#68B346",
    stroke: "white",
    strokeWidth: 1.18069
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeo4J);
export default __webpack_public_path__ + "static/media/neo4j.36630075cc0ae7165c85c40c02d09e02.svg";
export { ForwardRef as ReactComponent };